import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as core from '../../../core'

export enum SubContractPercent {
  UpTo24 = '0-24-percent',
  From25To49 = '25-49-percent',
  Over50 = '50-plus-percent',
}

const SUB_CONTRACT_PERCENTS: ReadonlySet<SubContractPercent> = new Set(
  Object.values(SubContractPercent) as SubContractPercent[],
)
export namespace SubContractPercent {
  export const ALL: readonly SubContractPercent[] = Array.from(
    SUB_CONTRACT_PERCENTS,
  )
  export const isSubContractPercent = TypeChecker.Factory.oneOf(
    SUB_CONTRACT_PERCENTS,
  )
  export const assertIsSubContractPercent: TypeAsserter<SubContractPercent> =
    TypeAsserter.Factory.from(isSubContractPercent)

  /**
   * Returns the {@link core.common.value.types.Enum.Entry} for the given
   * {@link SubContractPercent}
   */
  export function getEntry(
    subcontractPercent: SubContractPercent,
  ): core.common.value.types.Enum.Entry {
    return { ...ENTRY_LOOKUP[subcontractPercent], id: subcontractPercent }
  }
  /** Used by {@link getEntry} */
  const ENTRY_LOOKUP: Record<
    SubContractPercent,
    Omit<core.common.value.types.Enum.Entry, 'id'>
  > = {
    [SubContractPercent.UpTo24]: { name: '0-24%' },
    [SubContractPercent.From25To49]: {
      name: '25-49%',
    },
    [SubContractPercent.Over50]: {
      name: '50% +',
    },
  }
}
